import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RWidgetFormService {
  inputsSubject = new Subject<any>();
  constructor() {}
  inputsChange(value) {
    this.inputsSubject.next(value);
  }
  clearSubject() {
    this.inputsSubject.next();
    this.inputsSubject.complete();
    this.inputsSubject = new Subject<any>();
  }
}
